/* ==========================================================
   Testimonials Carousel — Swiper init
   Loaded only when the section file includes this asset,
   so it never runs on pages without the section.
   ========================================================== */

(function () {
  window.testimonialsSwiperInstances = window.testimonialsSwiperInstances || {};

  window.initTestimonialsCarousel = function (sectionId) {
    var wrapperEl = document.getElementById('TestimonialsCarousel-' + sectionId);
    if (!wrapperEl) return;

    var swiperEl = wrapperEl.querySelector('.testimonials-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // Destroy existing instance (theme editor re-renders sections on save)
    if (window.testimonialsSwiperInstances[sectionId]) {
      window.testimonialsSwiperInstances[sectionId].destroy(true, true);
    }

    var prevBtn = wrapperEl.querySelector('.testimonial-nav-btn--prev');
    var nextBtn = wrapperEl.querySelector('.testimonial-nav-btn--next');

    var autoplayEnabled = wrapperEl.dataset.autoplay === 'true';

    var swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 500,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    };

    if (autoplayEnabled) {
      var delay = parseInt(wrapperEl.dataset.autoplaySpeed, 10) || 5;
      swiperConfig.autoplay = {
        delay: delay * 1000,
        disableOnInteraction: false,
      };
    }

    window.testimonialsSwiperInstances[sectionId] = new Swiper(swiperEl, swiperConfig);
  };
})();
